import React, { FC, useCallback, useMemo, useState } from 'react';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop, hugeDesktop, largeDesktop } from 'helpers/utils/screensizes';
import Markdown from 'components/commercetools-ui/organisms/markdown';
import Image from 'frontastic/lib/image';
import Modal from '../modal';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import Slider from '../slider';
import Head from 'next/head';


interface ProductTileProps {
  section: any;
  data: any;
  index: number;
}

const TimeLineTile: FC<ProductTileProps> = ({ section, data, index }) => {
  const [isLargeDesktopSize] = useMediaQuery(hugeDesktop);
  const [isDesktopSize] = useMediaQuery(desktop);
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(index);
  const closeModal = useCallback(() => setIsOpen(false), []);

  function rotate(A:any, n:number, l = A.length) {
    const offset = ((n % l) + l) % l;
    return A.slice(offset).concat(A.slice(0, offset));
  }

  const revesredArray = rotate(data?.multiple_info, index);

  const webpUrl = section.image.url.replace(/\.[^/.]+$/, ".webp");
  return (
    <>
      <div
        className={`flex ${
          section.desktop_image_alignment === 'Top' ? 'flex-col' : 'flex-col-reverse'
        } relative items-start px-48 py-24 hover:cursor-pointer lg:items-center lg:px-0 lg:py-80 3xl:py-100 `}
      >
        {isDesktopSize && (
          <div
            className={`absolute !z-[999] text-center ${
              section.desktop_image_alignment === 'Top' ? 'top-15 3xl:top-10' : 'bottom-15 3xl:bottom-10'
            }`}
          >
            <span className="text-20 font-semibold text-primary-black 3xl:text-26">{section.title}</span>
            <Markdown markdown={section.description} className="text-12 font-semibold text-[#333] 3xl:text-16" />
          </div>
        )}
        <div className="flex items-center gap-24 ">
        <Head>
        <link
          rel="preload"
          href={webpUrl}
          as="image"
          imageSrcSet={`${webpUrl} 1200w,
          ${webpUrl}?w=200 200w, 
          ${webpUrl}?w=400 400w, 
          ${webpUrl}?w=800 800w, 
          ${webpUrl}?w=1024 1024w`}
        />
      </Head>
          <Image
            src={encodeURI(section.image.url)}
            alt={section.image.url}
            sizes="100vw"
            style={{
              width: '100%',
              height: 'auto',
              maxWidth: isLargeDesktopSize ? '120px' : '85px',
              minWidth: isLargeDesktopSize ? '120px' : '85px',
              objectFit: 'cover',
            }}
            width={100}
            height={100}
            onClick={() => setIsOpen(true)}
            />
          
          {!isDesktopSize && (
            <div>
              <span className="text-20 font-semibold text-primary-black 3xl:text-26">{section.title}</span>
              <Markdown markdown={section.description} className="text-12 font-semibold text-[#333] 3xl:text-16" />
            </div>
          )}
        </div>
      </div>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        // style={{ content: { background: 'transparent', border: 'none' } }}
        style={{ content: { backgroundColor: 'white', padding: '40px 40px 10px 40px' } }}
        closeButton
        className='border-transparent focus:border-transparent focus:ring-0 focus:outline-none'
        closeTimeoutMS={200}
      >
        <Slider
          slidesPerView={1}
          allowArrowsOnTouchDevice
          innerArrows
          dots={false}
          loop
          arrows={true}
          nextButtonStyles={{
            right: isDesktopSize?85:0,
            top: isDesktopSize?"50%":"38%",
            zIndex: 10,
            padding:'0px'

          }}
          prevButtonStyles={{
            left: isDesktopSize?85:0,
            top: isDesktopSize?"50%":"38%",
            zIndex: 10,
            padding:'0px'
          }}
          allowTouchMove
        >
          {revesredArray.map((section:any, index:number) => (
            <div className="flex flex-col items-center justify-center gap-24" key={index}>
              <span className="text-20 font-semibold text-primary-black 3xl:text-26">
                {section.content_with_icon[0].title}
              </span>


                <Image
                  src={encodeURI(section.content_with_icon[0].icon.url)}
                  alt={section.content_with_icon[0].icon.url}
                  sizes="100vw"
                  style={{
                    width: '100%',
                    height: 'auto',
                    maxWidth: isLargeDesktopSize ? '350px' : '200px',
                    minWidth: isLargeDesktopSize ? '350px' : '200px',
                    objectFit: 'cover',
                  }}
                  width={100}
                  height={100}
                  onClick={() => setIsOpen(true)}
                />
 

              <Markdown
                markdown={section.content_with_icon[0].content}
                className="h-[7rem] text-14 font-medium text-[#333] lg:h-[5rem] 3xl:text-16"
              />
            </div>
          ))}
          {/* <div className="flex flex-col items-center justify-center gap-24">
          <span className="text-20 font-semibold text-primary-black 3xl:text-26">
            {data?.multiple_info[currentIndex].content_with_icon[0].title}
          </span>
          <div className="flex items-center justify-center gap-24">
            <ChevronLeftIcon
              className="w-24 hover:cursor-pointer"
              onClick={() => {
                if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
              }}
            />

            <Image
              src={encodeURI(data?.multiple_info[currentIndex].content_with_icon[0].icon.url)}
              alt={data?.multiple_info[currentIndex].content_with_icon[0].icon.url}
              sizes="100vw"
              style={{
                width: '100%',
                height: 'auto',
                maxWidth: isLargeDesktopSize ? '350px' : '200px',
                minWidth: isLargeDesktopSize ? '350px' : '200px',
                objectFit: 'cover',
              }}
              width={100}
              height={100}
              onClick={() => setIsOpen(true)}
            />
            <ChevronRightIcon
              className="w-24 hover:cursor-pointer"
              onClick={() => {
                if (currentIndex < data?.multiple_info.length - 1) setCurrentIndex(currentIndex + 1);
              }}
            />
          </div>

          <Markdown
            markdown={data?.multiple_info[currentIndex].content_with_icon[0].content}
            className="text-14 font-medium text-[#333] 3xl:text-16 h-[6.5rem] lg:h-[5rem]"
            />
        </div> */}
        </Slider>
      </Modal>
    </>
  );
};

export default TimeLineTile;
